import { isHostComponent } from '@mui/base';

const shouldSpreadAdditionalProps = Slot => {
  return !Slot || !isHostComponent(Slot);
};

export default shouldSpreadAdditionalProps;